// src/pages/Help/components/FAQSection.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Button } from "reactstrap";

const FAQSection = ({ faqs }) => {
  const navigate = useNavigate();

  const handleFAQClick = () => {
    navigate("/help/faq");
  };

  const handleQuestionClick = () => {
    navigate("/help/faq");
  };

  return (
    <Card
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "4px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      }}
    >
      <CardBody style={{ padding: "16px" }}>
        <h5
          className="mb-3 fw-bold"
          style={{
            color: "#2F9E37",
            fontSize: "16px",
            lineHeight: "1.3",
          }}
        >
          Frequently Asked Questions
        </h5>

        <div className="mb-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              onClick={handleQuestionClick}
              style={{
                borderLeft: "4px solid #2F9E37",
                borderRight: "1px solid #2F9E37",
                borderTop: "1px solid #2F9E37",
                borderBottom: "1px solid #2F9E37",
                borderRadius: "4px",
                marginBottom: "8px",
                backgroundColor: "#fff",
                boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
                overflow: "hidden",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f9fafb";
                e.currentTarget.style.transform = "translateX(2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
                e.currentTarget.style.transform = "translateX(0)";
              }}
            >
              <div
                style={{
                  padding: "10px 14px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color: "#1f2937",
                    fontSize: "12px",
                    fontWeight: 500,
                    flex: 1,
                    lineHeight: "1.3",
                  }}
                >
                  {faq.question.length > 100
                    ? `${faq.question.substring(0, 90)}...`
                    : faq.question}
                </span>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "16px",
                    height: "16px",
                    borderRadius: "50%",
                    background: "#f3f4f6",
                    marginLeft: "8px",
                    flexShrink: 0,
                  }}
                >
                  <i
                    className="ri-arrow-right-line"
                    style={{
                      color: "#2F9E37",
                      fontSize: "10px",
                      fontWeight: "bold",
                    }}
                  ></i>
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom View Button */}
        <div className="text-end">
          <Button
            onClick={handleFAQClick}
            style={{
              backgroundColor: "#2F9E37",
              borderColor: "#2F9E37",
              color: "#ffffff",
              fontWeight: "600",
              padding: "6px 16px", // Reduced padding
              borderRadius: "4px",
              fontSize: "11px", // Smaller font
              border: "none",
              transition: "all 0.2s ease",
              width: "auto", // Auto width instead of 100%
              minWidth: "120px", // Minimum width for readability
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#27803d";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#2F9E37";
            }}
          >
            <i className="ri-external-link-line me-1"></i>
            View All FAQs
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default FAQSection;
